module.exports = __webpack_public_path__ + "static/media/bindOutlook1.dd57207f.png";